<template>
  <div class="chartElem">
    <div class="row align-center justify-center">
      <highcharts class="chart" :options="chartOptions" :updateArgs="updateArgs"></highcharts>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
      cursos: [
            'Materno',
            'Niño',
            'Adolescente',
            'Joven',
            'Adulto',
            'Adulto Mayor', 
        ],
        colores: [
          '#FFB7E9', // Materno
          '#1A89C0', // Niño
          '#FF9800', // Adolescente
          '#E5D335', //Joven
          '#A3B93D',  //Adulto
          '#1DA099' //Adulto Mayor
        ],
        titulos: [
            'Cuidado Integral de la Gestante',
            'Cuidado Integral del Niño',
            'Cuidado Integral del Adolescente',
            'Cuidado Integral del Joven',
            'Cuidado Integral del Adulto',
            'Cuidado Integral del Adulto Mayor', 
        ],
        grupos: [
            'NEONATO',
            'MENOR DE 1 AÑO',
            '1 AÑO',
            '2 AÑOS',
            '3 AÑOS',
            '4 AÑOS',
            'DE 5 a 11 AÑOS',
        ],
      title: '',
      points: [10, 0, 8, 2, 6, 4, 5, 5],
      chartType: 'Spline',
      seriesColor: 'red',
      colorInputIsSupported: null,
      animationDuration: 1200,
      updateArgs: [true, true, {duration: 1200}],
      chartOptions: {
        chart: {
          polar: true,
          type: 'line',
          height: 1000,
          width: 800
        },
        title: {
          text: 'Cuidado Integral',
          x: -80,
          style: {
            color: 'red',
            fontWeight: 'bold'
          }
        },
        pane: {
            size: '100%'
        },

        xAxis: {
            categories: [],
            tickmarkPlacement: 'on',
            lineWidth: 0,
        },

        yAxis: {
            gridLineInterpolation: 'polygon',
            lineWidth: 0,
            min: 0,
            labels: {
                style: {
                  hidden: true,
                  color: '#FF3333',
                  fontSize: '0px'
                },
                formatter: function () {
                    return this.value + ' %';
                }
            }
        },

        plotOptions: {
            area: {
                dataLabels: {
                    enabled: true,
                    color: 'black'
                },
            },
        },

        tooltip: {
            headerFormat: '<b>{series.name}</b><br/>',
            pointFormat: '{point.category}: {point.y}%'
        },

        legend: {
            align: 'right',
            verticalAlign: 'middle',
            layout: 'vertical'
        },

        series: [{
            name: 'Cuidado Integral',
            data: [],
            color: '#33C1FF',
            pointPlacement: 'on',
            type: 'area',
            showInLegend: false,
            dataLabels: {
                enabled: true,
                color: 'black',
                borderColor: "red",
                format: '{point.y} %',
                style: {
                  fontSize: '12px'
                },
                zIndex: 6,
                allowOverlap: true,
            },
        }],

        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ['viewFullscreen', 'downloadPNG', 'downloadJPEG', 'downloadPDF']
                }
            }
        },

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 1000,
                    maxHeigth: 800
                },
                chartOptions: {
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    pane: {
                        size: '80%'
                    }
                }
            }]
        }
      },
  }),
  created () {
    this.getIniciar()
  },
  props: ["serie", "datos", "categorias","grupo"],
  watch: {
    title (newValue) {
      this.chartOptions.title.text = newValue
    },
    points (newValue) {
      this.chartOptions.series[0].data = newValue
    },
    chartType (newValue) {
      this.chartOptions.chart.type = newValue.toLowerCase()
    },
    seriesColor (newValue) {
      this.chartOptions.series[0].color = newValue.toLowerCase()
    },
    animationDuration (newValue) {
      this.updateArgs[2].duration = Number(newValue)
    }
  },
  methods: {
    getIniciar() {
      this.chartOptions.title.text = 'Prueba'
      let titulo = this.titulos[this.serie-1]
      if(this.serie === 2){
        if(this.grupo === 0){
          titulo = 'CUIDADO INTEGRAL DEL ' + this.grupos[this.grupo]
        }
        else{
          titulo = titulo + ' - ' + this.grupos[this.grupo]
        }
      }
      this.chartOptions.title.text = titulo.toUpperCase()
      this.chartOptions.xAxis.categories = this.categorias
      this.chartOptions.series[0].name = ''
      this.chartOptions.series[0].data = this.datos
      this.chartOptions.series[0].color = this.colores[this.serie-1]
    },
  }
}
</script>
